import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import SelectField from "../../../../components/SelectField";
import Button from "../../../../components/Button";
import { Accordion, Modal } from "react-bootstrap";
import api from "../../../../api/api";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Select, { components } from "react-select";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShippingInstructionSection from "../../../../pages/Freight/Admin/MasterData/ShippingInstructionSection";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const EditContainerStatusReport = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showBLRegenerateConfirm, setShowBLRegenerateConfirm] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [blRegenerated, setBlRegenerated] = useState(false);
  const [downloadingBL, setDownloadingBL] = useState(false);
  const [portsOptions, setPortsOptions] = useState([]);
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);

  // Email modal states
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailRecipients, setEmailRecipients] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Estados para el modal de formato de descarga
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadType, setDownloadType] = useState(""); // 'shipping', 'final_bl', 'pre_alert'

  // Modificamos las funciones originales para abrir el modal primero
  const handleTriggerShippingDownload = () => {
    setDownloadType("shipping");
    setShowDownloadModal(true);
  };

  const handleTriggerFinalBLDownload = () => {
    setDownloadType("final_bl");
    setShowDownloadModal(true);
  };

  const handleTriggerPreAlertDownload = () => {
    setDownloadType("pre_alert");
    setShowDownloadModal(true);
  };

  // Función unificada que procesa la selección del usuario en el modal
  const handleExecuteDownload = (format) => {
    setShowDownloadModal(false);

    if (format === "excel") {
      switch (downloadType) {
        case "shipping":
          downloadShippingInstruction();
          break;

        case "final_bl":
          downloadFinalBL();
          break;

        case "pre_alert":
          downloadPreAlert();
          break;

        default:
          break;
      }
    }

    if (format === "pdf") {
      switch (downloadType) {
        case "shipping":
          downloadShippingInstructionPDF();
          break;

        case "final_bl":
          downloadFinalBLPDF();
          break;

        case "pre_alert":
          downloadPreAlertPDF();
          break;

        default:
          break;
      }
    }
  };

  // Stamp selection states
  const [selectedStamps, setSelectedStamps] = useState({
    containerStamps: [],
    descriptionStamps: [],
    measurementStamps: [],
  });

  // Delivery Agent selection
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState("");

  // Stamp options
  const containerStampOptions = [
    "ALL DESTINATION / DELIVERY CHARGES ON ACCOUNT OF CONSIGNEE AS PER CARRIER'S TARIFF",
    "DESTINATION CHARGES COLLECT",
    "SHIPPER'S LOAD STOW, COUNT SEAL AND WEIGHT",
    "LINER DEMURRAGE / DETENTION WILL BE PAYABLE TO LINER TARIFF",
    "DESTINATION CHARGES ON ACCOUNT OF CONSIGNEE",
    "DDC COLLECT",
    "DDC PREPAID",
  ];

  const descriptionStampOptions = [
    "FREIGHT PREPAID",
    "FREIGHT COLLECT",
    "ORIGIN CHARGES PREPAID",
    "ORIGIN CHARGES COLLECT",
    "DESTINATION CHARGES PREPAID",
    "DESTINATION CHARGES COLLECT",
    "DDC COLLECT",
    "DDC PREPAID",
  ];

  const measurementStampOptions = [
    "LCL/LCL",
    "LCL/FCL",
    "FCL/FCL",
    "PART OF 40'",
    "PART OF 20'",
  ];

  // Delivery Agent options
  const deliveryAgentOptions = [
    {
      value: "",
      label: "None",
    },
    {
      value:
        "PARSIAN GOLDEN ROUTE INTL TPT CO.,\nADDRESS NO.5, 2ND FLOOR, SOUTH\nBOZORGMEHR, 22 ST, SAJJAD BLVD, MASHAD, IRAN\nNATIONAL CODE: 10380647995\nREGISTRATION CODE : 48440",
      label: "PARSIAN GOLDEN ROUTE INTL TPT CO.",
    },
    {
      value:
        "NOBLE LINE LOGISTICS LLC\nOFFICE#21, 7TH FLOOR (IBC) DUBAI NATIONAL INSURANCE & REINSURANCE BUILDING, PORT SAEED, DEIRA, DUBAI,UAE.",
      label: "NOBLE LINE LOGISTICS LLC",
    },
    {
      value:
        "BAHAR TARABAR KIAN INTL TPT CO.\nUNIT 503,5TH FLOOR, ZAMEN AHOO COMPLEX, MAJD\nINTERSECTION,QARANI BLVD, MASHHAD, IRAN. POSTAL\nCODE:9195812137 NATIONAL\nID:10380647961/REGISTRATION CODE-48433\nCELL:00989019085261\nTEL:+985137289031-3 FAX:+985137289034\nE MAIL:BTK.FORWARDER@GMAIL.COM",
      label: "BAHAR TARABAR KIAN INTL TPT CO.",
    },
    {
      value:
        "NEW SAKSHI ASADULLAH LTD\nAYOBI DARMAL MARKET SHAH ZAMAN WATT KANDAHAR AFGHANISTAN\n 0704441230",
      label: "NEW SAKSHI ASADULLAH LTD",
    },
    {
      value:
        "KIAN MARINE STAR Shipping & International Freight\nADDRESS : No.9 3rd Floor NIA Budling Daneshmand intersection Pasdaran Blvd Bandar Abbas -IRAN\nEMAIL:manager@kianmarinestar.com.   National ID: 14012448401\nRegistration code 23259\nTEL:076-33548354-5",
      label: "KIAN MARINE STAR Shipping & International Freight",
    },
  ];

  // Get current user and check if they can edit
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const allowedEditors = ["GFR003", "GFR009", "wMe2inT9YF9i"];
  const canEdit = allowedEditors.includes(user?.user_id);

  // Place of Issue options
  const placeOfIssueOptions = [
    { value: "Mumbai", label: "Mumbai (22)" },
    { value: "New Delhi", label: "New Delhi (11)" },
    { value: "Chennai", label: "Chennai (44)" },
    { value: "Kolkatta", label: "Kolkatta (33)" },
    { value: "Chandigarh", label: "Chandigarh (72)" },
  ];

  // Fetch ports for dropdown
  const fetchPorts = async () => {
    try {
      const res = await api.get("/ports");
      const options = res.data.map((p) => ({
        value: p.Port_names,
        label: p.Port_names,
      }));
      setPortsOptions(options);
    } catch (err) {
      console.error("Error fetching ports:", err);
    }
  };

  // GET API - Fetch enquiry details
  const fetchEnquiry = async () => {
    try {
      const response = await api.get(
        `/master-data/container-status-report/${id}`,
      );
      const enquiryData = response.data.enquiry;
      setEnquiry(enquiryData);

      // Load stamps from database (if exists)
      if (enquiryData.stamps) {
        try {
          const parsedStamps = JSON.parse(enquiryData.stamps);
          setSelectedStamps(parsedStamps);
        } catch (e) {
          console.error("Error parsing stamps:", e);
        }
      }

      // Load delivery agent from database (if exists)
      if (enquiryData.delivery_agent) {
        setSelectedDeliveryAgent(enquiryData.delivery_agent);
      }
    } catch (error) {
      console.error(" Error fetching enquiry:", error);
      alert("Failed to fetch enquiry data. Please check the console.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiry();
    fetchPorts();
  }, [id]);

  const updateContainerStatusReport = async (payload) => {
    try {
      const response = await api.put(
        `/master-data/container-status-report`,
        payload,
      );
      console.log(" Update Response:", response.data);

      // Set appropriate success message based on whether BL was regenerated
      if (payload.regenerateBL) {
        setBlRegenerated(true);
        setSuccessMessage(
          "BL draft regenerated successfully! Click OK to download.",
        );
      } else {
        setBlRegenerated(false);
        setSuccessMessage("Container Status Report updated successfully!");
      }
      setShowSuccess(true);
    } catch (error) {
      console.error("❌ Error updating container status report:", error);
      alert(
        "Failed to update container status report. Please check the console.",
      );
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: enquiry
      ? {
          ...enquiry,
          containers: (enquiry.containerDetails || []).map((c) => ({
            ...c,
            container_number: c.container_number || "",
            seal_number: c.seal_number || "",
          })),
        }
      : {
          customer_name: "",
          booking_id: "",
          ports_of_loading: "",
          ports_discharge: "",
          place_reciept: "",
          place_delivery: "",
          freight_terms: "",
          origin_charge_terms: "",
          destination_charge: "",
          freight_payable_at: "",
          first_shipper_name: "",
          consignee_name: "",
          container_type: "",
          container_count: "",
          number_of_documents: "",
          number_of_originals: "",
          hs_code: "",
          hs_description: "",
          gross_weight: "",
          General_Description_Goods: "",
          number_packages: "",
          container_number: "",
          liner_seal_number: "",
          custom_seal_number: "",
          freight_charges: "",
          origin_charges: "",
          dest_charge_terms: "",
          charges_unit: "",
          charges_currency: "",
          shipper_address: "",
          consignee_address: "",
          notify_party_1: "",
          notify_party_2: "",
          notify_party_1_address: "",
          notify_party_2_address: "",
          shipping_bill_number: "",
          commercial_invoice_number: "",
          shipping_bill_date: "",
          marks_and_packages: "",
          net_weight: "",
          iec_number: "",
          mode_of_transport: "",
          route_shipment: "",
          vessel_name: "",
          voyage_number: "",
          vessel_operator: "",
          agent_details: "",
          place_of_issue: "",
          date_of_issue: "",
          fob_value: "",
          est_sailing_date: "",
          cut_off_date: "",
          form_13_cut_off_date: "",
          sailing_date: "",
          shipped_onboard: "",
          cargo_arrival_notice: "",
          pul_pin_code: "",
          dol_pin_code: "",
          document_type: "",
          nature_of_cargo: "",
          containers: [],
        },
    onSubmit: () => {
      // Check if status is "Quotation Accepted" or "Shipping Instruction Created" - show normal confirm
      // Otherwise show BL regeneration warning
      if (
        enquiry?.Status &&
        (enquiry.Status === "Quotation Accepted" ||
          enquiry.Status === "Shipping Instruction Created")
      ) {
        setShowConfirm(true);
      } else {
        setShowBLRegenerateConfirm(true);
      }
    },
  });

  // Handle confirmation for "Quotation Accepted" status (normal update)
  const handleConfirm = async () => {
    setLoadingSubmit(true);
    try {
      setShowConfirm(false);
      const payload = {
        ...formik.values,
        enquiry_id: id,
        notificationType: "shared",
        regenerateBL: false,
        stamps: selectedStamps,
        delivery_agent: selectedDeliveryAgent,
      };
      await updateContainerStatusReport(payload);
    } finally {
      setLoadingSubmit(false);
    }
  };

  // Handle BL regeneration confirmation - User clicked "Yes"
  const handleBLRegenerateYes = async () => {
    setLoadingSubmit(true);
    try {
      // First, update the container status report
      const updatePayload = {
        ...formik.values,
        enquiry_id: id,
        notificationType: "shared",
        regenerateBL: true,
        stamps: selectedStamps,
        delivery_agent: selectedDeliveryAgent,
      };

      const updateResponse = await api.put(
        `/master-data/container-status-report`,
        updatePayload,
      );

      console.log("Update Response:", updateResponse.data);

      // If update was successful and needs BL regeneration, call sendBL API
      if (updateResponse.data.needsBLRegeneration) {
        // Prepare data for sendBL API - regenerateOnly mode skips WhatsApp
        const sendBLData = {
          enq_id: id,
          stamps: selectedStamps,
          deliveryAgent: selectedDeliveryAgent,
          regenerateOnly: true, // Skip WhatsApp sending during regeneration
        };

        // Call sendBL API to regenerate BL (route is /api/si-admin/sendBL)
        const blResponse = await api.post(`/si-admin/sendBL`, sendBLData);
        console.log("BL Regeneration Response:", blResponse.data);

        setBlRegenerated(true);
        setSuccessMessage(
          "BL draft regenerated successfully! Click OK to download.",
        );
      } else {
        setBlRegenerated(false);
        setSuccessMessage("Container Status Report updated successfully!");
      }

      // Close the modal after operation completes
      setShowBLRegenerateConfirm(false);
      setShowSuccess(true);
    } catch (error) {
      console.error("❌ Error updating container status report:", error);
      // Close modal on error too
      setShowBLRegenerateConfirm(false);
      alert(
        "Failed to update container status report. Please check the console.",
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  // Handle BL regeneration confirmation - User clicked "No" (cancel everything)
  const handleBLRegenerateNo = () => {
    setShowBLRegenerateConfirm(false);
    // Do nothing - no update, no regeneration
  };

  const handleSuccessClose = async () => {
    // If BL was regenerated, download it automatically before closing
    if (blRegenerated) {
      await handleDownloadBL();
    }
    setShowSuccess(false);
    navigate("/master-data/container-status-report");
  };

  // Handle cross/close icon click - just close without downloading
  const handleSuccessCloseWithoutDownload = () => {
    setShowSuccess(false);
    navigate("/master-data/container-status-report");
  };

  // Handle download of regenerated BL
  const handleDownloadBL = async () => {
    setDownloadingBL(true);
    try {
      const response = await api.get(
        `/download-document/bl/${id}?documentName=BL Draft`,
        { responseType: "blob" },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `BL_Draft_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      // If download fails, provide option to navigate to BL list
      if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        alert(
          "Unable to download BL due to network error. Please go to BL List to download the BL manually.",
        );
      } else {
        alert("Failed to download BL. Please try again or go to BL List.");
      }
    } finally {
      setDownloadingBL(false);
    }
  };

  const handleSendEmail = () => {
    setShowEmailModal(true);
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!emailRecipients.trim()) {
      setEmailError("Please enter at least one email address.");
      return;
    }
    setEmailLoading(true);
    setEmailError("");
    try {
      await api.post(`/quotation/send-email/${id}`, { recipients: emailRecipients });
      setEmailSuccess(true);
      setShowEmailModal(false);
      setEmailRecipients("");
    } catch (err) {
      console.error("Error sending email:", err);
      setEmailError("Failed to send email. Please try again.");
    } finally {
      setEmailLoading(false);
    }
  };

  const handleEmailModalClose = () => {
    setShowEmailModal(false);
    setEmailRecipients("");
    setEmailError("");
  };

  const handleEmailSuccessClose = () => {
    setEmailSuccess(false);
  };

  const handleSendWhatsApp = async () => {
    setSendingWhatsApp(true);
    try {
      // Replace with your proper WhatsApp trigger endpoint
      await api.post(`/si-admin/send-whatsapp/${id}`);
      alert("WhatsApp message sent successfully!");
    } catch (error) {
      console.error("Failed to send WhatsApp:", error);
      alert("Failed to send WhatsApp message.");
    } finally {
      setSendingWhatsApp(false);
    }
  };
  const downloadShippingInstruction = () => {
    const data = [];

    // Heading
    data.push(["Shipping Instruction"]);
    data.push([]);

    // Form Fields
    data.push(["Shipper Name", formik.values.shipper_name]);
    data.push(["Notify Party", formik.values.notify_party]);
    data.push(["Consignee Name", formik.values.consignee_name]);
    data.push(["Port of Loading", formik.values.port_of_loading]);
    data.push(["Port of Discharge", formik.values.port_of_discharge]);
    data.push(["Marks & Numbers", formik.values.marks_and_numbers]);
    data.push([
      "Number & Kind of Packages",
      formik.values.number_and_kind_of_packages,
    ]);
    data.push(["Gross Weight", formik.values.gross_weight]);
    data.push(["Place of Receipt", formik.values.place_of_receipt]);
    data.push(["Measurements", formik.values.measurements]);
    data.push(["Place of Delivery", formik.values.place_of_delivery]);
    data.push([
      "Total Number of Containers",
      formik.values.total_number_of_containers,
    ]);
    data.push(["Number of Originals", formik.values.number_of_originals]);
    data.push(["Freight Terms", formik.values.freight_terms]);
    data.push(["Vessel Name", formik.values.vessel_name]);
    data.push(["Voyage No", formik.values.voyage_no]);
    data.push(["Document Type", formik.values.document_type]);
    data.push(["Mode of Shipment", formik.values.mode_of_shipment]);
    data.push([
      "General Description of Goods",
      formik.values.general_description_of_goods,
    ]);

    // React Select values
    data.push(["Delivery Agent", selectedDeliveryAgent || ""]);
    // data.push(["Place of Issue", selectedPlaceOfIssue || ""]);
    // data.push([
    //   "Date of Issue",
    //   dateOfIssue ? new Date(dateOfIssue).toLocaleDateString("en-GB") : "",
    // ]);

    // BL2 (only if applicable)
    // if (
    //   enquiry?.switch_bl === "Yes" ||
    //   enquiry?.document_type === "Switch BL"
    // ) {
    //   data.push([
    //     "Date of Issue (BL2)",
    //     dateOfIssueBl2
    //       ? new Date(dateOfIssueBl2).toLocaleDateString("en-GB")
    //       : "",
    //   ]);
    // }

    // data.push(["BL Source", selectedBLSource || ""]);

    // Selected Stamps
    data.push(["Container Stamps", selectedStamps.containerStamps.join(", ")]);

    data.push([
      "Description Stamps",
      selectedStamps.descriptionStamps.join(", "),
    ]);

    data.push([
      "Measurement Stamps",
      selectedStamps.measurementStamps.join(", "),
    ]);

    data.push([]);
    data.push(["Containers"]);

    // Table Header
    data.push([
      "Container Type",
      "Weight",
      "Length",
      "Height",
      "Breadth",
      "Container Number",
      "Seal Number",
    ]);

    // Table Data
    formik.values.containers.forEach((container) => {
      data.push([
        container.container_type,
        container.container_weight,
        container.container_length,
        container.container_height,
        container.container_breadth,
        container.container_number,
        container.seal_number,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Shipping");

    XLSX.writeFile(workbook, "Shipping_Instruction.xlsx");
  };
  const downloadShippingInstructionPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Shipping Instruction", 14, 20);

    let y = 35;

    const fields = [
      ["Shipper Name", formik.values.shipper_name],
      ["Notify Party", formik.values.notify_party],
      ["Consignee", formik.values.consignee_name],
      ["Port Of Loading", formik.values.port_of_loading],
      ["Port Of Discharge", formik.values.port_of_discharge],
      ["Gross Weight", formik.values.gross_weight],
      ["Measurements", formik.values.measurements],
      ["Freight Terms", formik.values.freight_terms],
      ["Vessel Name", formik.values.vessel_name],
      ["Voyage", formik.values.voyage_no],
    ];

    fields.forEach(([label, value]) => {
      doc.text(`${label} : ${value || ""}`, 14, y);
      y += 8;
    });

    autoTable(doc, {
      startY: y + 5,
      head: [
        [
          "Container Type",
          "Weight",
          "Length",
          "Height",
          "Breadth",
          "Container Number",
          "Seal Number",
        ],
      ],
      body: formik.values.containers.map((c) => [
        c.container_type,
        c.container_weight,
        c.container_length,
        c.container_height,
        c.container_breadth,
        c.container_number,
        c.seal_number,
      ]),
    });

    doc.save("Shipping_Instruction.pdf");
  };

  const downloadFinalBL = () => {
    const data = [];

    data.push(["Final BL"]);
    data.push([]);

    // Form Fields
    data.push(["Customer Name", formik.values.client_name]);
    data.push(["Booking Number", formik.values.booking_id]);
    data.push(["Port Of Loading", formik.values.pol]);
    data.push(["Port Of Discharge", formik.values.pod]);
    data.push(["Place Of Receipt", formik.values.Placeof_Receipt]);
    data.push(["Place Of Delivery", formik.values.Placeof_Delivery]);
    data.push(["Freight Terms", formik.values.freight_terms]);
    data.push(["Origin Charge Terms", formik.values.origin_charge_terms]);
    data.push(["Destination Charge", formik.values.destination_charge]);
    data.push([
      "Freight Payable At",
      formik.values.freight_terms === "Prepaid" ? "ORIGIN" : "DESTINATION",
    ]);

    data.push(["Shipper Name", formik.values.first_shipper_name]);
    data.push(["Shipper Address", formik.values.first_shipper_address]);
    data.push(["Consignee Name", formik.values.first_consignee_name]);
    data.push(["Consignee Address", formik.values.first_consignee_address]);

    data.push(["Notify Party 1", formik.values.notify_party_1]);
    data.push(["Notify Party 1 Address", formik.values.notify_party_1_address]);
    data.push(["Notify Party 2", formik.values.notify_party_2]);
    data.push(["Notify Party 2 Address", formik.values.notify_party_2_address]);

    data.push(["Container Type", formik.values.container_type]);
    data.push(["Container Count", formik.values.number_of_containers]);

    data.push(["HS Code", formik.values.hs_code]);
    data.push(["HS Description", formik.values.hs_description]);

    data.push(["Gross Weight", formik.values.gross_weight]);
    data.push(["Net Weight", formik.values.net_weight]);

    data.push(["Number Of Packages", formik.values.packaging_count]);
    data.push(["General Description", formik.values.general_description]);

    data.push(["Shipping Bill Number", formik.values.shipping_bill_number]);
    data.push([
      "Commercial Invoice Number",
      formik.values.commercial_invoice_number,
    ]);
    data.push(["Shipping Bill Date", formik.values.shipping_bill_date]);

    data.push(["Marks & Packages", formik.values.marks_and_packages]);

    data.push(["Freight Charges", formik.values.freight_charges]);
    data.push(["Origin Charges", formik.values.origin_charges]);
    data.push(["Destination Charge Terms", formik.values.dest_charge_terms]);
    data.push(["Charges Unit", formik.values.charges_unit]);
    data.push(["Charges Currency", formik.values.charges_currency]);

    data.push(["IEC Number", formik.values.iec_number]);

    data.push(["Mode Of Transport", formik.values.mode_of_shipment]);
    data.push(["Route Shipment", formik.values.route_shipment]);

    data.push(["Vessel Name", formik.values.vessel_name]);
    data.push(["Voyage Number", formik.values.voyage_number]);
    data.push(["Vessel Operator", formik.values.vessel_operator]);
    data.push(["Agent Details", formik.values.agent_details]);

    data.push(["Place Of Issue", formik.values.place_of_issue]);
    data.push(["Date Of Issue", formik.values.date_of_issue]);

    data.push(["FOB Value", formik.values.fob_value]);

    data.push(["Estimated Sailing Date", formik.values.est_sailing_date]);
    data.push(["Cut Off Date", formik.values.cut_off_date]);
    data.push(["Form 13 Cut Off Date", formik.values.form_13_cut_off_date]);
    data.push(["Sailing Date", formik.values.sailing_date]);
    data.push(["Shipped Onboard", formik.values.shipped_onboard]);

    data.push(["Cargo Arrival Notice", formik.values.cargo_arrival_notice]);

    data.push(["PUL PIN", formik.values.pul_pin_code]);
    data.push(["DOL PIN", formik.values.dol_pin_code]);

    data.push(["Document Type", formik.values.document_type]);
    data.push(["Original Documents", formik.values.number_of_originals]);

    data.push(["Nature Of Cargo", formik.values.nature_of_cargo]);

    data.push([]);
    data.push(["Container Details"]);

    data.push([
      "Container Type",
      "Weight",
      "Length",
      "Height",
      "Breadth",
      "Temperature",
      "Container Number",
      "Seal Number",
    ]);

    formik.values.containers.forEach((container) => {
      data.push([
        container.container_type,
        container.container_weight,
        container.container_length,
        container.container_height,
        container.container_breadth,
        container.container_temperature || "",
        container.container_number,
        container.seal_number,
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Final BL");

    XLSX.writeFile(wb, "Final_BL.xlsx");
  };
  const downloadFinalBLPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.text("Final Bill Of Lading", 14, 18);

    doc.setFontSize(10);

    const body = [
      ["Customer Name", formik.values.client_name || ""],
      ["Booking Number", formik.values.booking_id || ""],
      ["Port Of Loading", formik.values.pol || ""],
      ["Port Of Discharge", formik.values.pod || ""],
      ["Place Of Receipt", formik.values.Placeof_Receipt || ""],
      ["Place Of Delivery", formik.values.Placeof_Delivery || ""],
      ["Freight Terms", formik.values.freight_terms || ""],
      ["Origin Charge Terms", formik.values.origin_charge_terms || ""],
      ["Destination Charge", formik.values.destination_charge || ""],
      [
        "Freight Payable At",
        formik.values.freight_terms === "Prepaid" ? "ORIGIN" : "DESTINATION",
      ],

      ["Shipper Name", formik.values.first_shipper_name || ""],
      ["Shipper Address", formik.values.first_shipper_address || ""],

      ["Consignee Name", formik.values.first_consignee_name || ""],
      ["Consignee Address", formik.values.first_consignee_address || ""],

      ["Notify Party 1", formik.values.notify_party_1 || ""],
      ["Notify Party 1 Address", formik.values.notify_party_1_address || ""],

      ["Notify Party 2", formik.values.notify_party_2 || ""],
      ["Notify Party 2 Address", formik.values.notify_party_2_address || ""],

      ["Container Type", formik.values.container_type || ""],
      ["Container Count", formik.values.number_of_containers || ""],

      ["HS Code", formik.values.hs_code || ""],
      ["HS Description", formik.values.hs_description || ""],

      ["Gross Weight", formik.values.gross_weight || ""],
      ["Net Weight", formik.values.net_weight || ""],

      ["Number Of Packages", formik.values.packaging_count || ""],
      ["General Description", formik.values.general_description || ""],

      ["Shipping Bill Number", formik.values.shipping_bill_number || ""],
      [
        "Commercial Invoice Number",
        formik.values.commercial_invoice_number || "",
      ],
      ["Shipping Bill Date", formik.values.shipping_bill_date || ""],

      ["Marks & Packages", formik.values.marks_and_packages || ""],

      ["Freight Charges", formik.values.freight_charges || ""],
      ["Origin Charges", formik.values.origin_charges || ""],
      ["Destination Charge Terms", formik.values.dest_charge_terms || ""],
      ["Charges Unit", formik.values.charges_unit || ""],
      ["Charges Currency", formik.values.charges_currency || ""],

      ["IEC Number", formik.values.iec_number || ""],

      ["Mode Of Transport", formik.values.mode_of_shipment || ""],
      ["Route Shipment", formik.values.route_shipment || ""],

      ["Vessel Name", formik.values.vessel_name || ""],
      ["Voyage Number", formik.values.voyage_number || ""],
      ["Vessel Operator", formik.values.vessel_operator || ""],
      ["Agent Details", formik.values.agent_details || ""],

      ["Place Of Issue", formik.values.place_of_issue || ""],
      ["Date Of Issue", formik.values.date_of_issue || ""],

      ["FOB Value", formik.values.fob_value || ""],

      ["Estimated Sailing Date", formik.values.est_sailing_date || ""],
      ["Cut Off Date", formik.values.cut_off_date || ""],
      ["Form 13 Cut Off Date", formik.values.form_13_cut_off_date || ""],
      ["Sailing Date", formik.values.sailing_date || ""],
      ["Shipped Onboard", formik.values.shipped_onboard || ""],

      ["Cargo Arrival Notice", formik.values.cargo_arrival_notice || ""],

      ["PUL PIN", formik.values.pul_pin_code || ""],
      ["DOL PIN", formik.values.dol_pin_code || ""],

      ["Document Type", formik.values.document_type || ""],
      ["Original Documents", formik.values.number_of_originals || ""],

      ["Nature Of Cargo", formik.values.nature_of_cargo || ""],
    ];

    autoTable(doc, {
      startY: 25,
      head: [["Field", "Value"]],
      body,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [41, 128, 185],
      },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 120 },
      },
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 10,
      head: [
        [
          "Container Type",
          "Weight",
          "Length",
          "Height",
          "Breadth",
          "Temperature",
          "Container Number",
          "Seal Number",
        ],
      ],
      body: formik.values.containers.map((container) => [
        container.container_type || "",
        container.container_weight || "",
        container.container_length || "",
        container.container_height || "",
        container.container_breadth || "",
        container.container_temperature || "",
        container.container_number || "",
        container.seal_number || "",
      ]),
      theme: "grid",
      styles: {
        fontSize: 8,
      },
      headStyles: {
        fillColor: [52, 152, 219],
      },
    });

    doc.save("Final_BL.pdf");
  };

  const renderTooltip = (text) => (
    <Tooltip id={`tooltip-${text.replace(/\s+/g, "-").toLowerCase()}`}>
      {text}
    </Tooltip>
  );
  const downloadPreAlert = () => {
    const data = [];

    data.push(["Pre Alert"]);
    data.push([]);

    data.push(["Vessel Name", formik.values.vessel_name]);
    data.push(["Voyage Number", formik.values.voyage_number]);
    data.push(["Vessel Operator", formik.values.vessel_operator]);
    data.push(["Agent Details", formik.values.agent_details]);

    data.push(["FOB Value", formik.values.fob_value]);

    data.push(["Estimated Sailing Date", formik.values.est_sailing_date]);
    data.push(["Cut Off Date", formik.values.cut_off_date]);
    data.push(["Form 13 Cut Off Date", formik.values.form_13_cut_off_date]);
    data.push(["Sailing Date", formik.values.sailing_date]);
    data.push(["Shipped Onboard", formik.values.shipped_onboard]);

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Pre Alert");

    XLSX.writeFile(wb, "Pre_Alert.xlsx");
  };

  const downloadPreAlertPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.text("Pre Alert", 14, 18);

    const body = [
      ["Vessel Name", formik.values.vessel_name || ""],
      ["Voyage Number", formik.values.voyage_number || ""],
      ["Vessel Operator", formik.values.vessel_operator || ""],
      ["Agent Details", formik.values.agent_details || ""],

      ["FOB Value", formik.values.fob_value || ""],

      ["Estimated Sailing Date", formik.values.est_sailing_date || ""],
      ["Cut Off Date", formik.values.cut_off_date || ""],
      ["Form 13 Cut Off Date", formik.values.form_13_cut_off_date || ""],
      ["Sailing Date", formik.values.sailing_date || ""],
      ["Shipped Onboard", formik.values.shipped_onboard || ""],
    ];

    autoTable(doc, {
      startY: 25,
      head: [["Field", "Value"]],
      body,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [41, 128, 185],
      },
      columnStyles: {
        0: {
          cellWidth: 60,
          fontStyle: "bold",
        },
        1: {
          cellWidth: 120,
        },
      },
    });

    doc.save("Pre_Alert.pdf");
  };

  if (loading) return <div>Loading...</div>;
  if (!enquiry) return <div>No data found for this enquiry.</div>;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <Breadcrumbs breadcrumbcls="position-static p-0" />
        {canEdit && (
          <Button text="Job Closer" variant="primary" type="submit" />
        )}
      </div>
      <Accordion defaultActiveKey="0" className="customaccordion">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            Shipping Instruction
            <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="download-tooltip">Download</Tooltip>}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={handleTriggerShippingDownload}
                    loading={downloadingBL}
                  >
                    <DownloadIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="email-tooltip">Send Email</Tooltip>}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleSendEmail}
                  >
                    <EmailIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="whatsapp-tooltip">Send WhatsApp</Tooltip>}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-success"
                    onClick={handleSendWhatsApp}
                    loading={sendingWhatsApp}
                  >
                    <WhatsAppIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>
            </div>
          </Accordion.Header>

          <Accordion.Body>
            <ShippingInstructionSection />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            Final BL
            <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Download Final BL")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={handleTriggerFinalBLDownload}
                    loading={downloadingBL}
                  >
                    <DownloadIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Send Email")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleSendEmail}
                  >
                    <EmailIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Send WhatsApp")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-success"
                    onClick={handleSendWhatsApp}
                    loading={sendingWhatsApp}
                  >
                    <WhatsAppIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>
            </div>
          </Accordion.Header>

          <Accordion.Body>
            {/* <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
              <Button
                type="button"
                variant="outline-primary"
                // onClick={downloadFinalBL}
                onClick={handleTriggerFinalBLDownload}
                loading={downloadingBL}
              >
                <DownloadIcon className="me-1 fs-6" /> Download
              </Button>

              <Button
                type="button"
                variant="outline-secondary"
                onClick={handleSendEmail}
              >
                <EmailIcon className="me-1 fs-6" /> Send Email
              </Button>

              <Button
                type="button"
                variant="outline-success"
                onClick={handleSendWhatsApp}
                loading={sendingWhatsApp}
              >
                <WhatsAppIcon className="me-1 fs-6" /> Send WhatsApp
              </Button>
            </div> */}

            <form onSubmit={formik.handleSubmit}>
              <div className="row py-4">
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Customer Name"
                    name="client_name"
                    placeholder="Customer Name"
                    value={formik.values.client_name}
                    onChange={formik.handleChange}
                    disabled={true}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Booking Number"
                    name="booking_id"
                    placeholder="Booking Number"
                    value={formik.values.booking_id}
                    onChange={formik.handleChange}
                    disabled={true}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Port of Loading</label>
                  <Select
                    name="ports_of_loading"
                    options={portsOptions}
                    value={portsOptions.find(
                      (opt) => opt.value === formik.values.pol,
                    )}
                    onChange={(option) =>
                      formik.setFieldValue("pol", option ? option.value : "")
                    }
                    placeholder="Select Port of Loading..."
                    className="basic-select"
                    classNamePrefix="select"
                    isDisabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Ports of Discharge</label>
                  <Select
                    name="ports_discharge"
                    options={portsOptions}
                    value={portsOptions.find(
                      (opt) => opt.value === formik.values.pod,
                    )}
                    onChange={(option) =>
                      formik.setFieldValue("pod", option ? option.value : "")
                    }
                    placeholder="Select Port of Discharge..."
                    className="basic-select"
                    classNamePrefix="select"
                    isDisabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Place of Receipt"
                    placeholder="Place of Receipt"
                    name="Placeof_Receipt"
                    value={formik.values.Placeof_Receipt}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Place of Delivery"
                    placeholder="Place of Delivery"
                    name="Placeof_Delivery"
                    value={formik.values.Placeof_Delivery}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Freight Terms</label>
                  <select
                    className="form-select"
                    name="freight_terms"
                    value={formik.values.freight_terms}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  >
                    <option value="">Select Freight Terms</option>
                    <option value="Prepaid">Prepaid</option>
                    <option value="Collect">Collect</option>
                  </select>
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Origin Charge Terms"
                    placeholder="Origin Charge Terms"
                    name="origin_charge_terms"
                    value={formik.values.origin_charge_terms}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Destination Charge"
                    placeholder="Destination Charge"
                    name="destination_charge"
                    value={formik.values.destination_charge}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Freight Payable At"
                    placeholder="Freight Payable At"
                    name="freight_payable_at"
                    value={
                      formik.values.freight_terms === "Prepaid"
                        ? "ORIGIN"
                        : "DESTINATION"
                    }
                    disabled
                    title="This field is auto-calculated based on Freight Terms. To change this value, please update the Freight Terms field."
                    style={{
                      cursor: "not-allowed",
                      backgroundColor: "#f5f5f5",
                    }}
                  />
                </div>

                {/* Shipper / Consignee Info */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipper Name"
                    placeholder="Shipper Name"
                    name="first_shipper_name"
                    value={formik.values.first_shipper_name}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Consignee Name"
                    placeholder="Consignee Name"
                    name="first_consignee_name"
                    value={formik.values.first_consignee_name}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Container Info */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Container Type"
                    placeholder="Container Type"
                    name="container_type"
                    value={formik.values.container_type}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Container Count"
                    placeholder="Container Count"
                    name="number_of_containers"
                    value={formik.values.number_of_containers}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Number of Documents"
                    placeholder="Number of Documents"
                    name="document_count"
                    value={formik.values.document_count}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="HS Code"
                    placeholder="HS Code"
                    name="hs_code"
                    value={formik.values.hs_code}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="HS Description"
                    placeholder="HS Description"
                    name="hs_description"
                    value={formik.values.hs_description}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Gross Weight"
                    placeholder="Gross Weight"
                    name="gross_weight"
                    value={formik.values.gross_weight}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="General Description of Goods"
                    placeholder="General  Description of Goods"
                    name="general_description"
                    type="textarea"
                    value={formik.values.general_description}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Number of Packages"
                    placeholder="Number of Packages"
                    name="packaging_count"
                    value={formik.values.packaging_count}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Container Table for assigning container_number and seal_number */}
                {formik.values.containers &&
                  formik.values.containers.length > 0 && (
                    <div className="col-12 mb-3">
                      <h5 className="fs-6 fw-bold">
                        Please Assign Container Number and Seal Number to the
                        following containers.
                      </h5>
                      <table
                        className="table table-bordered"
                        style={{ marginTop: "10px" }}
                      >
                        <thead>
                          <tr>
                            {enquiry?.shipment_segment !== "LE" &&
                              enquiry?.shipment_segment !== "LI" && (
                                <th>Container Type</th>
                              )}
                            <th>Weight</th>
                            <th>Length</th>
                            <th>Height</th>
                            <th>Breadth</th>
                            {enquiry?.nature_of_cargo ===
                              "Temperature Control" && <th>Temperature</th>}
                            <th>Container Number</th>
                            <th>Seal Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formik.values.containers.map((container, index) => (
                            <tr key={index}>
                              {enquiry?.shipment_segment !== "LE" &&
                                enquiry?.shipment_segment !== "LI" && (
                                  <td>{container.container_type}</td>
                                )}
                              <td>{container.container_weight}</td>
                              <td>{container.container_length}</td>
                              <td>{container.container_height}</td>
                              <td>{container.container_breadth}</td>
                              {enquiry?.nature_of_cargo ===
                                "Temperature Control" && (
                                <td>{container.container_temperature}</td>
                              )}
                              <td>
                                <InputField
                                  name={`containers.${index}.container_number`}
                                  placeholder="Enter Container Number"
                                  value={
                                    formik.values.containers[index]
                                      ?.container_number || ""
                                  }
                                  onChange={formik.handleChange}
                                  disabled={!canEdit}
                                />
                              </td>
                              <td>
                                <InputField
                                  name={`containers.${index}.seal_number`}
                                  placeholder="Enter Seal Number"
                                  value={
                                    formik.values.containers[index]
                                      ?.seal_number || ""
                                  }
                                  onChange={formik.handleChange}
                                  disabled={!canEdit}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Freight Charges"
                    placeholder="Freight Charges"
                    name="freight_charges"
                    value={formik.values.freight_charges}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Origin Charges"
                    placeholder="Origin Charges"
                    name="origin_charges"
                    value={formik.values.origin_charges}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Destination Charge Terms"
                    placeholder="Destination Charge Terms"
                    name="dest_charge_terms"
                    value={formik.values.dest_charge_terms}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Charges Unit"
                    placeholder="Charges Unit"
                    name="charges_unit"
                    value={formik.values.charges_unit}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Charges Currency"
                    placeholder="Charges Currency"
                    name="charges_currency"
                    value={formik.values.charges_currency}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Address Fields */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipper Address"
                    placeholder="Shipper Address"
                    name="first_shipper_address"
                    value={formik.values.first_shipper_address}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Consignee Address"
                    placeholder="Consignee Address"
                    name="first_consignee_address"
                    value={formik.values.first_consignee_address}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Notify Party 1"
                    placeholder="Notify Party 1"
                    name="notify_party_1"
                    value={formik.values.notify_party_1}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Notify Party 2"
                    placeholder="Notify Party 2"
                    name="notify_party_2"
                    value={formik.values.notify_party_2}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Notify Party 1 Address"
                    placeholder="Notify Party 1 Address"
                    name="notify_party_1_address"
                    value={formik.values.notify_party_1_address}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Notify Party 2 Address"
                    placeholder="Notify Party 2 Address"
                    name="notify_party_2_address"
                    value={formik.values.notify_party_2_address}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Shipping Bill Info */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipping Bill Number"
                    placeholder="Shipping Bill Number"
                    name="shipping_bill_number"
                    value={formik.values.shipping_bill_number}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Commercial Invoice Number"
                    placeholder="Commercial Invoice Number"
                    name="commercial_invoice_number"
                    value={formik.values.commercial_invoice_number}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipping Bill Date"
                    placeholder="Shipping Bill Date"
                    name="shipping_bill_date"
                    value={formik.values.shipping_bill_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Marks Number Packages"
                    placeholder="Marks Number Packages"
                    name="marks_and_packages"
                    type="textarea"
                    value={formik.values.marks_and_packages}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Net Weight"
                    placeholder="Net Weight"
                    name="net_weight"
                    value={formik.values.net_weight}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="IEC Number"
                    placeholder="IEC Number"
                    name="iec_number"
                    value={formik.values.iec_number}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Transport Details */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Mode of Transport"
                    placeholder="Mode of Transport"
                    name="mode_of_transport"
                    value={formik.values.mode_of_shipment}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Route/Shipment"
                    placeholder="Route/Shipment"
                    name="route_shipment"
                    value={formik.values.route_shipment}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Vessel Name"
                    placeholder="Vessel Name"
                    name="vessel_name"
                    value={formik.values.vessel_name}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Voyage Number"
                    placeholder="Voyage Number"
                    name="voyage_number"
                    value={formik.values.voyage_number}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Vessel Operator"
                    placeholder="Vessel Operator"
                    name="vessel_operator"
                    value={formik.values.vessel_operator}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Agent Details"
                    placeholder="Agent Details"
                    name="agent_details"
                    value={formik.values.agent_details}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Issue Details */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Place of Issue</label>
                  <Select
                    name="place_of_issue"
                    options={placeOfIssueOptions}
                    value={placeOfIssueOptions.find(
                      (opt) => opt.value === formik.values.place_of_issue,
                    )}
                    onChange={(option) =>
                      formik.setFieldValue(
                        "place_of_issue",
                        option ? option.value : "",
                      )
                    }
                    placeholder="Select Place of Issue..."
                    className="basic-select"
                    classNamePrefix="select"
                    isDisabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Date of Issue</label>
                  <input
                    type="date"
                    name="date_of_issue"
                    className="form-control"
                    value={
                      formik.values.date_of_issue
                        ? formik.values.date_of_issue.split("T")[0]
                        : ""
                    }
                    onChange={(e) =>
                      formik.setFieldValue("date_of_issue", e.target.value)
                    }
                    placeholder="Select Date of Issue"
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="FOB Value"
                    placeholder="FOB Value"
                    name="fob_value"
                    value={formik.values.fob_value}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Dates */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Est. Sailing Date"
                    placeholder="Est. Sailing Date"
                    name="est_sailing_date"
                    value={formik.values.est_sailing_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Cut Off Date"
                    placeholder="Cut Off Date"
                    name="cut_off_date"
                    value={formik.values.cut_off_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Form 13 Cut Off Date"
                    placeholder="Form 13 Cut Off Date"
                    name="form_13_cut_off_date"
                    value={formik.values.form_13_cut_off_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Sailing Date"
                    placeholder="Sailing Date"
                    name="sailing_date"
                    value={formik.values.sailing_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipped Onboard"
                    placeholder="Shipped Onboard"
                    name="shipped_onboard"
                    value={formik.values.shipped_onboard}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Cargo & PIN */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Cargo Arrival Notice"
                    placeholder="Cargo Arrival Notice"
                    name="cargo_arrival_notice"
                    value={formik.values.cargo_arrival_notice}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="PUL PIN Code"
                    placeholder="PUL PIN Code"
                    name="pul_pin_code"
                    value={formik.values.pul_pin_code}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="DOL PIN Code"
                    placeholder="DOL PIN Code"
                    name="dol_pin_code"
                    value={formik.values.dol_pin_code}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Document Type"
                    placeholder="Document Type"
                    name="document_type"
                    value={formik.values.document_type}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Number of Originals"
                    placeholder="Number of Originals"
                    name="number_of_originals"
                    type="number"
                    value={formik.values.number_of_originals || ""}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Nature of Cargo"
                    placeholder="Nature of Cargo"
                    name="nature_of_cargo"
                    value={formik.values.nature_of_cargo}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Select Stamps for BL</label>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    name="allStamps"
                    // Tooltip
                    components={{
                      MultiValueLabel: (props) => (
                        <components.MultiValueLabel {...props}>
                          <div
                            title={props.data.label}
                            style={{
                              maxWidth: "80px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {props.data.label}
                          </div>
                        </components.MultiValueLabel>
                      ),
                    }}
                    options={[
                      ...containerStampOptions.map((stamp) => ({
                        value: `container:${stamp}`,
                        label: stamp,
                      })),
                      ...descriptionStampOptions.map((stamp) => ({
                        value: `description:${stamp}`,
                        label: stamp,
                      })),
                      ...measurementStampOptions.map((stamp) => ({
                        value: `measurement:${stamp}`,
                        label: stamp,
                      })),
                    ]}
                    value={[
                      ...selectedStamps.containerStamps.map((stamp) => ({
                        value: `container:${stamp}`,
                        label: stamp,
                      })),
                      ...selectedStamps.descriptionStamps.map((stamp) => ({
                        value: `description:${stamp}`,
                        label: stamp,
                      })),
                      ...selectedStamps.measurementStamps.map((stamp) => ({
                        value: `measurement:${stamp}`,
                        label: stamp,
                      })),
                    ]}
                    onChange={(options) => {
                      const container = [];
                      const description = [];
                      const measurement = [];

                      options?.forEach((opt) => {
                        const [type, value] = opt.value.split(":");
                        if (type === "container") container.push(value);
                        else if (type === "description")
                          description.push(value);
                        else if (type === "measurement")
                          measurement.push(value);
                      });

                      setSelectedStamps({
                        containerStamps: container,
                        descriptionStamps: description,
                        measurementStamps: measurement,
                      });
                    }}
                    placeholder="Search & Select Stamps"
                    classNamePrefix="select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        maxHeight: "35px",
                        minHeight: "35px",
                        border: "1px solid #ced4da",
                        backgroundColor: "aliceblue",
                        boxShadow: "none",
                        overflow: "hidden",
                        borderRadius: "0.5rem",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "35px",
                        overflowY: "auto",
                        flexWrap: "nowrap",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        fontSize: "10px",
                        maxWidth: "90px",
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "100px",
                        overflowY: "auto",
                        fontSize: "12px",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#cfe2ff"
                          : state.isFocused
                            ? "#e9ecef"
                            : "#fff",
                        color: "#000",
                        fontWeight: state.isSelected ? "600" : "400",
                      }),
                    }}
                  />
                </div>

                {/* Delivery Agent Selection */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <label className="form-label">Delivery Agent</label>
                  <Select
                    name="deliveryAgent"
                    options={deliveryAgentOptions}
                    value={deliveryAgentOptions.find(
                      (opt) => opt.value === selectedDeliveryAgent,
                    )}
                    onChange={(option) =>
                      setSelectedDeliveryAgent(option ? option.value : "")
                    }
                    placeholder="Select Delivery Agent..."
                    classNamePrefix="select"
                    isDisabled={!canEdit}
                  />
                </div>
              </div>

              {/* Submit button - Only visible for authorized users */}
              {/* {canEdit && (
          <div className="d-flex justify-content-end mt-3">
            <Button text="Update Booking" variant="primary" type="submit" />
          </div>
        )} */}
            </form>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            Pre Alert
            <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Download Pre Alert")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={handleTriggerPreAlertDownload}
                    loading={downloadingBL}
                  >
                    <DownloadIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Send Email")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleSendEmail}
                  >
                    <EmailIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Send WhatsApp")}
              >
                <span>
                  <Button
                    type="button"
                    variant="outline-success"
                    onClick={handleSendWhatsApp}
                    loading={sendingWhatsApp}
                  >
                    <WhatsAppIcon className="me-1 fs-6" />
                  </Button>
                </span>
              </OverlayTrigger>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            {/* <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
              <Button
                type="button"
                variant="outline-primary"
             
                onClick={handleTriggerPreAlertDownload}
                loading={downloadingBL}
              >
                <DownloadIcon className="me-1 fs-6" />
              </Button>

              <Button
                type="button"
                variant="outline-secondary"
                onClick={handleSendEmail}
              >
                <EmailIcon className="me-1 fs-6" />
              </Button>

              <Button
                type="button"
                variant="outline-success"
                onClick={handleSendWhatsApp}
                loading={sendingWhatsApp}
              >
                <WhatsAppIcon className="me-1 fs-6" />
              </Button>
            </div> */}

            <form onSubmit={formik.handleSubmit}>
              <div className="row py-4">
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Vessel Name"
                    placeholder="Vessel Name"
                    name="vessel_name"
                    value={formik.values.vessel_name}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Voyage Number"
                    placeholder="Voyage Number"
                    name="voyage_number"
                    value={formik.values.voyage_number}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Vessel Operator"
                    placeholder="Vessel Operator"
                    name="vessel_operator"
                    value={formik.values.vessel_operator}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Agent Details"
                    placeholder="Agent Details"
                    name="agent_details"
                    value={formik.values.agent_details}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="FOB Value"
                    placeholder="FOB Value"
                    name="fob_value"
                    value={formik.values.fob_value}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                {/* Dates */}
                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Est. Sailing Date"
                    placeholder="Est. Sailing Date"
                    name="est_sailing_date"
                    value={formik.values.est_sailing_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Cut Off Date"
                    placeholder="Cut Off Date"
                    name="cut_off_date"
                    value={formik.values.cut_off_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Form 13 Cut Off Date"
                    placeholder="Form 13 Cut Off Date"
                    name="form_13_cut_off_date"
                    value={formik.values.form_13_cut_off_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Sailing Date"
                    placeholder="Sailing Date"
                    name="sailing_date"
                    value={formik.values.sailing_date}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>

                <div className="col-sm-6 col-md-4 mb-3">
                  <InputField
                    label="Shipped Onboard"
                    placeholder="Shipped Onboard"
                    name="shipped_onboard"
                    value={formik.values.shipped_onboard}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>
              </div>

              {canEdit && (
                <div className="d-flex justify-content-end mt-3">
                  <Button text="Update" variant="primary" type="submit" />
                </div>
              )}
            </form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {/* Confirm Modal - For Quotation Accepted status */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to update this report?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button
            text="Confirm"
            variant="primary"
            onClick={handleConfirm}
            loading={loadingSubmit}
          />
        </Modal.Footer>
      </Modal>

      {/* BL Regeneration Confirm Modal - For status other than Quotation Accepted */}
      <Modal
        show={showBLRegenerateConfirm}
        onHide={() => !loadingSubmit && setShowBLRegenerateConfirm(false)}
        centered
      >
        <Modal.Header closeButton={!loadingSubmit}>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Updating these values will regenerate the existing BL draft? Do you
          want to regenerate the BL draft?
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="No"
            variant="secondary"
            onClick={handleBLRegenerateNo}
            disabled={loadingSubmit}
          />
          <Button
            text="Yes, Update & Regenerate BL"
            variant="primary"
            onClick={handleBLRegenerateYes}
            loading={loadingSubmit}
          />
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal
        show={showSuccess}
        onHide={handleSuccessCloseWithoutDownload}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>{successMessage}</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>

      {/* Email Modal */}
      <Modal show={showEmailModal} onHide={handleEmailModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleEmailSubmit}>
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="emailRecipients" className="form-label">
                Email Addresses (comma-separated)
              </label>
              <input
                type="text"
                className="form-control"
                id="emailRecipients"
                value={emailRecipients}
                onChange={(e) => setEmailRecipients(e.target.value)}
                placeholder="e.g., user1@example.com, user2@example.com"
                required
              />
              {emailError && (
                <div className="text-danger mt-1">{emailError}</div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              text="Cancel"
              variant="secondary"
              onClick={handleEmailModalClose}
            />
            <Button
              text={emailLoading ? "Sending..." : "Send Email"}
              variant="primary"
              type="submit"
              disabled={emailLoading}
            />
          </Modal.Footer>
        </form>
      </Modal>

      {/* Email Success Modal */}
      <Modal show={emailSuccess} onHide={handleEmailSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Email sent successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleEmailSuccessClose} />
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmación y selección de formato para descargas */}
      <Modal
        show={showDownloadModal}
        onHide={() => setShowDownloadModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Format</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Please choose the format you would like to download .
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => handleExecuteDownload("excel")}
          >
            Excel
          </Button>

          <Button variant="danger" onClick={() => handleExecuteDownload("pdf")}>
            PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditContainerStatusReport;
